<template>
  <div class="section" id="password-chage">
      <div class="columns is-flex-direction-column">
        <div class="column is-half-desktop is-offset-one-quarter-desktop"
        >
          <h1 class="subtitle">パスワード変更</h1>
          <p class="block">パスワードの変更が完了しました。</p>
          <div class="formbutton">
            <router-link to="/profile/">
              <b-button type="is-primary">
                登録情報に戻る
              </b-button>
            </router-link>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordChangeCompleted'
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/passwordchange-completed.scss';
</style>
